import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getSubserviceCategories } from "../../../api/service";

export const fetchSubCategories = createAsyncThunk("fetchSubCategories", async () => {
  const res = await getSubserviceCategories();
  return res;
});

const initialState = {
  isLoading: false
};

const subCategorySlice = createSlice({
  name: "subcategory",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubCategories.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchSubCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.res = action.payload;
      })
      .addCase(fetchSubCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});
export const { reset } = subCategorySlice.actions;
export { subCategorySlice };
